import React from 'react';
import { styled, Box } from '@mui/material';
import MemberHomeRouting from '../../routing/MemberHomeRouting';
import { LAYOUT_CONSTANTS } from '../../theme';

const PREFIX = 'MemberLayout';

const classes = {
  container: `${PREFIX}-container`,
};

const StyledBox = styled(Box)(({ theme }) => ({
  [`&.${classes.container}`]: {
    ['& .responsive-container']: {
      padding: theme.spacing(2),
      maxWidth: `calc(${theme.spacing(LAYOUT_CONSTANTS.MAX_CONTENT_WIDTH)} + ${theme.spacing(LAYOUT_CONSTANTS.CONTENT_PADDING)})`,
      margin: '0 auto',
      display: 'flex',
      flexDirection: 'column',
      minHeight: `calc(100vh - ${theme.spacing(LAYOUT_CONSTANTS.HEADER_HEIGHT)} - ${theme.spacing(LAYOUT_CONSTANTS.FOOTER_HEIGHT)})`,
      overflow: 'auto',
      ['&:has(.standout-section)']: {
        maxWidth: '100%',
        ['& [class*="-container"]']: {
          margin: '0 auto',
          width: '100%',
          maxWidth: `calc(${theme.spacing(LAYOUT_CONSTANTS.MAX_CONTENT_WIDTH)} + ${theme.spacing(LAYOUT_CONSTANTS.CONTENT_PADDING)})`,
        },
        ['& .standout-section']: {
          marginLeft: theme.spacing(-3),
          marginTop: theme.spacing(-3),
          marginRight: theme.spacing(-3),
          marginBottom: theme.spacing(3),
          ['& .standout-section-content']: {
            margin: '0 auto',
            width: '100%',
            maxWidth: `calc(${theme.spacing(LAYOUT_CONSTANTS.MAX_CONTENT_WIDTH)} + ${theme.spacing(LAYOUT_CONSTANTS.CONTENT_PADDING)})`,
          },
        },
      },
      ['&:has(.TripDetailsPage-container)']: {
        padding: 0,
      },
      [theme.breakpoints.up('md')]: {
        padding: theme.spacing(3),
      },
    },
  },
}));

function MemberLayout() {
  return (
    <StyledBox className={classes.container}>
      <main className="responsive-container" id="content">
        <MemberHomeRouting />
        <div className="spacer"></div>
      </main>
    </StyledBox>
  );
}

export default MemberLayout;
